import { computed, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Events } from '@ngrx/signals/events';
import { catchError, EMPTY, Subject, switchMap } from 'rxjs';

import { NotificationsCountApiService } from './api/notifications-count-api.service';
import type { NotificationCount } from './api/requests.models';
import { requestEvents } from './events/request.events';

const NOTHING_WAITING: NotificationCount = {
  openShiftsAwaitingReaction: 0,
  exchangesAwaitingApproval: 0,
  exchangesAwaitingReaction: 0,
  absencesAwaitingApproval: 0,
};

@Injectable({ providedIn: 'root' })
export class RequestsBadgeService {
  #api = inject(NotificationsCountApiService);
  #events = inject(Events);

  #counts = signal(NOTHING_WAITING);
  #refresh$ = new Subject<void>();

  supervisorCount = computed(() => this.#counts().exchangesAwaitingApproval + this.#counts().absencesAwaitingApproval);
  myCount = computed(() => this.#counts().openShiftsAwaitingReaction + this.#counts().exchangesAwaitingReaction);

  constructor() {
    this.#refresh$
      .pipe(
        switchMap(() => this.#api.getCount().pipe(catchError(() => EMPTY))),
        takeUntilDestroyed(),
      )
      .subscribe((counts) => this.#counts.set(counts));

    this.refresh();

    this.#events
      .on(requestEvents.resolved)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.refresh());
  }

  refresh(): void {
    this.#refresh$.next();
  }
}
